import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
  Card,
  CardContent,
  Typography,
  Stack,
  Box,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CruzeAdminTable = ({ admins = [], onEdit }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  /* ========== MOBILE VIEW ========== */
  if (isMobile) {
    return (
      <Stack spacing={2}>
        {admins.map((admin) => (
          <Card key={admin._id} elevation={3}>
            <CardContent>
              <Typography variant="h6" fontWeight={600}>
                {admin.firstname} {admin.lastname}
              </Typography>

              <Typography variant="body2">
                Email: {admin.email}
              </Typography>

              <Typography variant="body2">
                Phone: {admin.phonenumber}
              </Typography>

              <Typography variant="body2">
                Role: <Chip size="small" label={admin.role} />
              </Typography>

              <Typography variant="body2">
                Modules: {admin.module?.join(", ")}
              </Typography>

              <Box mt={2} textAlign="right">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => onEdit(admin)}
                >
                  Edit
                </Button>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Stack>
    );
  }

  /* ========== DESKTOP VIEW ========== */
  return (
    <TableContainer component={Paper} elevation={3}>
      <Table>
        <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
          <TableRow>
            <TableCell><b>Name</b></TableCell>
            <TableCell><b>Email</b></TableCell>
            <TableCell><b>Phone</b></TableCell>
            <TableCell><b>Role</b></TableCell>
            <TableCell><b>Modules</b></TableCell>
            <TableCell align="right"><b>Action</b></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {admins.map((admin) => (
            <TableRow key={admin._id} hover>
              <TableCell>
                {admin.firstname} {admin.lastname}
              </TableCell>
              <TableCell>{admin.email}</TableCell>
              <TableCell>{admin.phonenumber}</TableCell>
              <TableCell>
                <Chip size="small" label={admin.role} />
              </TableCell>
              <TableCell>
                {admin.module?.join(", ")}
              </TableCell>
              <TableCell align="right">
                <Button onClick={() => onEdit(admin)}>
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CruzeAdminTable;
